import { Component, Prop, Emit, Mixins, Watch } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBRadio from './SBRadio';


@Component({
})
export default class SBRadioGroup extends Mixins(SBComponentVue) {
    @Prop({
        type: [String, Boolean],
        default: "",
    })
    public value!: string | boolean;

    @Emit("input")
    public input(val: string | boolean) {
        return val;
    }

    public getValue() {
        return this.value;
    }

    public setValue(value: string | boolean) {
        this.input(value);
    }

}
